<div class="dahsboard-header-div">
    <div class="visitor-div">
        <div class="logo-container">
          <img class="img-logo" alt="SmarterPlanLogo" src="../assets/images/logos/logo-reserve.png">
        </div>
        <div class="avatar-container-menu">
          <div class="profile_pic dropdown-toggle" data-bs-toggle="dropdown" data-testid="dropdown-menu-button">
            <lib-avatar></lib-avatar>
          </div>
          <div class="dropdown-menu dropdown-menu-right" >
            <a class="dropdown-item" routerLink="/dashboard">{{'Hotels' | translate}}</a>
            <a class="dropdown-item" data-testid="user-management-btn" routerLink="/admin">{{'Users' | translate}}</a>
            <!-- <button class="dropdown-item" (click)="openSupportForm()">{{"Help" | translate}}</button> -->
            <button data-testid="logout-auth-btn" class="dropdown-item" (click)="signOut()" data-testid="logout-auth-btn">{{"Logout" |
              translate}}</button>
          </div>
        </div>
    </div>
</div>
